// extracted by mini-css-extract-plugin
export default {"preview":"Preview_preview__0xytr"};